<template>
  <div class="container-fluid w-100" style="overflow: hidden">
    <navbar v-if="!editMode" :title="$t('menu.observation_collections')" />
    <Transition name="fade">
      <observation-collection-list
        v-if="!editMode"
        :results="results"
        :observation-types="observationTypes"
        @add="addNew"
        @edit="edit"
      />
    </Transition>

    <div
      v-if="editMode"
      class="col-sm-12 nopads"
    >
      <Transition name="fade">
        <observation-collection-editor
          ref="obsCollectionEditor"
          :observation-collection="observationCollection"
          :observation-types="observationTypes"
          @close="showList"
          @close-and-update="closeAndUpdate"
        />
      </Transition>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import ObservationCollectionList from "@/components/observation/collection/ObservationCollectionList";
import ObservationCollectionEditor from "@/components/observation/collection/ObservationCollectionEditor";
import Navbar from "@/components/utils/Navbar.vue";

export default {
    name: 'ObservationCollections',
    components: {Navbar, ObservationCollectionEditor, ObservationCollectionList},
    mixins: [restApi],
    data: function () {
        return {
            results: [],
            observationCollection: null,
            observationTypes: [],
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchObservationTypes()
        this.fetchObservationCollections()
    },
    methods: {
        fetchObservationCollections: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.observationCollectionUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        fetchObservationTypes: function () {
            this.loading = true
            this.observationTypes = []
            this.restFetch(this.observationTypeUrl, this.handleObservationTypes)
        },
        handleObservationTypes: function (response) {
            this.observationTypes = response.data
            this.loading = false
        },
        addNew: function () {
            this.observationCollection = {id: null, name: null, observation_types: null}
            this.editMode = true
        },
        edit: function (observationCollection) {
            this.observationCollection = observationCollection
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchObservationCollections()
            this.showList()
        }

    }
}
</script>
